/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import type { Controller, ControllerInterface } from '../Controller'

const _abi = [
  {
    inputs: [],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      }
    ],
    name: 'OperatorUpdated',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [],
    name: 'Paused',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'withdrawnFee0',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'withdrawnFee1',
        type: 'uint256'
      }
    ],
    name: 'ProtocolFeeWithdrawn',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [],
    name: 'UnPaused',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'vaultId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'owner',
        type: 'address'
      }
    ],
    name: 'VaultCreated',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_rangeId',
        type: 'bytes32'
      },
      {
        internalType: 'uint256',
        name: '_perpUr',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_elapsed',
        type: 'uint256'
      }
    ],
    name: 'calculateLPTBorrowerAndLenderPremium',
    outputs: [
      {
        internalType: 'uint256',
        name: 'premiumGrowthForBorrower',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'premiumGrowthForLender',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'protocolFeePerLiquidity',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'subVaultId',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'asset0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'asset1',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debt0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debt1',
            type: 'uint256'
          },
          {
            components: [
              {
                internalType: 'bool',
                name: 'isCollateral',
                type: 'bool'
              },
              {
                internalType: 'uint128',
                name: 'liquidity',
                type: 'uint128'
              },
              {
                internalType: 'int24',
                name: 'lowerTick',
                type: 'int24'
              },
              {
                internalType: 'int24',
                name: 'upperTick',
                type: 'int24'
              }
            ],
            internalType: 'struct DataType.LPT[]',
            name: 'lpts',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct DataType.Position[]',
        name: '_positions',
        type: 'tuple[]'
      },
      {
        components: [
          {
            internalType: 'bool',
            name: 'isLiquidationCall',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'swapAnyway',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'quoterMode',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'isQuoteZero',
            type: 'bool'
          },
          {
            internalType: 'uint8',
            name: 'marginMode0',
            type: 'uint8'
          },
          {
            internalType: 'uint8',
            name: 'marginMode1',
            type: 'uint8'
          },
          {
            internalType: 'int256',
            name: 'deltaMarginAmount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'deltaMarginAmount1',
            type: 'int256'
          },
          {
            internalType: 'bytes',
            name: 'metadata',
            type: 'bytes'
          }
        ],
        internalType: 'struct DataType.TradeOption',
        name: '_tradeOption',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'lowerSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upperSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'swapRatio',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'closeRatio',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          }
        ],
        internalType: 'struct DataType.ClosePositionOption',
        name: '_closePositionOptions',
        type: 'tuple'
      }
    ],
    name: 'closePosition',
    outputs: [
      {
        components: [
          {
            internalType: 'int256',
            name: 'amount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'amount1',
            type: 'int256'
          }
        ],
        internalType: 'struct DataType.TokenAmounts',
        name: 'requiredAmounts',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'int256',
            name: 'amount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'amount1',
            type: 'int256'
          }
        ],
        internalType: 'struct DataType.TokenAmounts',
        name: 'swapAmounts',
        type: 'tuple'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_subVaultId',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'bool',
            name: 'isLiquidationCall',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'swapAnyway',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'quoterMode',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'isQuoteZero',
            type: 'bool'
          },
          {
            internalType: 'uint8',
            name: 'marginMode0',
            type: 'uint8'
          },
          {
            internalType: 'uint8',
            name: 'marginMode1',
            type: 'uint8'
          },
          {
            internalType: 'int256',
            name: 'deltaMarginAmount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'deltaMarginAmount1',
            type: 'int256'
          },
          {
            internalType: 'bytes',
            name: 'metadata',
            type: 'bytes'
          }
        ],
        internalType: 'struct DataType.TradeOption',
        name: '_tradeOption',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'lowerSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upperSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'swapRatio',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'closeRatio',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          }
        ],
        internalType: 'struct DataType.ClosePositionOption',
        name: '_closePositionOptions',
        type: 'tuple'
      }
    ],
    name: 'closeSubVault',
    outputs: [
      {
        components: [
          {
            internalType: 'int256',
            name: 'amount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'amount1',
            type: 'int256'
          }
        ],
        internalType: 'struct DataType.TokenAmounts',
        name: 'requiredAmounts',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'int256',
            name: 'amount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'amount1',
            type: 'int256'
          }
        ],
        internalType: 'struct DataType.TokenAmounts',
        name: 'swapAmounts',
        type: 'tuple'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'bool',
            name: 'isLiquidationCall',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'swapAnyway',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'quoterMode',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'isQuoteZero',
            type: 'bool'
          },
          {
            internalType: 'uint8',
            name: 'marginMode0',
            type: 'uint8'
          },
          {
            internalType: 'uint8',
            name: 'marginMode1',
            type: 'uint8'
          },
          {
            internalType: 'int256',
            name: 'deltaMarginAmount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'deltaMarginAmount1',
            type: 'int256'
          },
          {
            internalType: 'bytes',
            name: 'metadata',
            type: 'bytes'
          }
        ],
        internalType: 'struct DataType.TradeOption',
        name: '_tradeOption',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'lowerSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upperSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'swapRatio',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'closeRatio',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          }
        ],
        internalType: 'struct DataType.ClosePositionOption',
        name: '_closePositionOptions',
        type: 'tuple'
      }
    ],
    name: 'closeVault',
    outputs: [
      {
        components: [
          {
            internalType: 'int256',
            name: 'amount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'amount1',
            type: 'int256'
          }
        ],
        internalType: 'struct DataType.TokenAmounts',
        name: 'requiredAmounts',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'int256',
            name: 'amount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'amount1',
            type: 'int256'
          }
        ],
        internalType: 'struct DataType.TokenAmounts',
        name: 'swapAmounts',
        type: 'tuple'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getContext',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      },
      {
        internalType: 'address',
        name: '',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      }
    ],
    name: 'getPosition',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'subVaultId',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'asset0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'asset1',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debt0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debt1',
            type: 'uint256'
          },
          {
            components: [
              {
                internalType: 'bool',
                name: 'isCollateral',
                type: 'bool'
              },
              {
                internalType: 'uint128',
                name: 'liquidity',
                type: 'uint128'
              },
              {
                internalType: 'int24',
                name: 'lowerTick',
                type: 'int24'
              },
              {
                internalType: 'int24',
                name: 'upperTick',
                type: 'int24'
              }
            ],
            internalType: 'struct DataType.LPT[]',
            name: 'lpts',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct DataType.Position[]',
        name: '',
        type: 'tuple[]'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      }
    ],
    name: 'getPositionCalculatorParams',
    outputs: [
      {
        components: [
          {
            internalType: 'int256',
            name: 'marginAmount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'marginAmount1',
            type: 'int256'
          },
          {
            internalType: 'uint256',
            name: 'asset0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'asset1',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debt0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debt1',
            type: 'uint256'
          },
          {
            components: [
              {
                internalType: 'bool',
                name: 'isCollateral',
                type: 'bool'
              },
              {
                internalType: 'uint128',
                name: 'liquidity',
                type: 'uint128'
              },
              {
                internalType: 'int24',
                name: 'lowerTick',
                type: 'int24'
              },
              {
                internalType: 'int24',
                name: 'upperTick',
                type: 'int24'
              }
            ],
            internalType: 'struct DataType.LPT[]',
            name: 'lpts',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct PositionCalculator.PositionCalculatorParams',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_rangeId',
        type: 'bytes32'
      }
    ],
    name: 'getRange',
    outputs: [
      {
        components: [
          {
            internalType: 'int24',
            name: 'lowerTick',
            type: 'int24'
          },
          {
            internalType: 'int24',
            name: 'upperTick',
            type: 'int24'
          },
          {
            internalType: 'uint128',
            name: 'borrowedLiquidity',
            type: 'uint128'
          },
          {
            internalType: 'uint256',
            name: 'premiumGrowthForBorrower',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'premiumGrowthForLender',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'fee0Growth',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'fee1Growth',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'lastTouchedTimestamp',
            type: 'uint256'
          }
        ],
        internalType: 'struct DataType.PerpStatus',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getSqrtIndexPrice',
    outputs: [
      {
        internalType: 'uint160',
        name: '',
        type: 'uint160'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getSqrtPrice',
    outputs: [
      {
        internalType: 'uint160',
        name: 'sqrtPriceX96',
        type: 'uint160'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_subVaultId',
        type: 'uint256'
      }
    ],
    name: 'getSubVault',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256'
          },
          {
            components: [
              {
                internalType: 'enum BaseToken.InterestType',
                name: 'interestType',
                type: 'uint8'
              },
              {
                internalType: 'uint256',
                name: 'assetAmount',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'debtAmount',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'lastAssetGrowth',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'lastDebtGrowth',
                type: 'uint256'
              }
            ],
            internalType: 'struct BaseToken.AccountState',
            name: 'balance0',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'enum BaseToken.InterestType',
                name: 'interestType',
                type: 'uint8'
              },
              {
                internalType: 'uint256',
                name: 'assetAmount',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'debtAmount',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'lastAssetGrowth',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'lastDebtGrowth',
                type: 'uint256'
              }
            ],
            internalType: 'struct BaseToken.AccountState',
            name: 'balance1',
            type: 'tuple'
          },
          {
            components: [
              {
                internalType: 'bool',
                name: 'isCollateral',
                type: 'bool'
              },
              {
                internalType: 'bytes32',
                name: 'rangeId',
                type: 'bytes32'
              },
              {
                internalType: 'uint128',
                name: 'liquidityAmount',
                type: 'uint128'
              },
              {
                internalType: 'uint256',
                name: 'premiumGrowthLast',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'fee0Last',
                type: 'uint256'
              },
              {
                internalType: 'uint256',
                name: 'fee1Last',
                type: 'uint256'
              }
            ],
            internalType: 'struct DataType.LPTState[]',
            name: 'lpts',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct DataType.SubVault',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getTokenState',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'totalCompoundDeposited',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'totalCompoundBorrowed',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'totalNormalDeposited',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'totalNormalBorrowed',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'assetScaler',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debtScaler',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'assetGrowth',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debtGrowth',
            type: 'uint256'
          }
        ],
        internalType: 'struct BaseToken.TokenState',
        name: '',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'totalCompoundDeposited',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'totalCompoundBorrowed',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'totalNormalDeposited',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'totalNormalBorrowed',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'assetScaler',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debtScaler',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'assetGrowth',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debtGrowth',
            type: 'uint256'
          }
        ],
        internalType: 'struct BaseToken.TokenState',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_rangeId',
        type: 'bytes32'
      }
    ],
    name: 'getUtilizationRatio',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      }
    ],
    name: 'getVault',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'vaultId',
            type: 'uint256'
          },
          {
            internalType: 'int256',
            name: 'marginAmount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'marginAmount1',
            type: 'int256'
          },
          {
            internalType: 'uint256[]',
            name: 'subVaults',
            type: 'uint256[]'
          }
        ],
        internalType: 'struct DataType.Vault',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        internalType: 'uint160',
        name: '_sqrtPriceX96',
        type: 'uint160'
      }
    ],
    name: 'getVaultStatus',
    outputs: [
      {
        components: [
          {
            internalType: 'int256',
            name: 'positionValue',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'marginValue',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'minCollateral',
            type: 'int256'
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: 'uint256',
                    name: 'assetValue',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'debtValue',
                    type: 'uint256'
                  },
                  {
                    internalType: 'int256',
                    name: 'premiumValue',
                    type: 'int256'
                  }
                ],
                internalType: 'struct DataType.SubVaultValue',
                name: 'values',
                type: 'tuple'
              },
              {
                components: [
                  {
                    internalType: 'uint256',
                    name: 'assetAmount0',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'assetAmount1',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'debtAmount0',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'debtAmount1',
                    type: 'uint256'
                  }
                ],
                internalType: 'struct DataType.SubVaultAmount',
                name: 'amount',
                type: 'tuple'
              },
              {
                components: [
                  {
                    internalType: 'int256',
                    name: 'assetFee0',
                    type: 'int256'
                  },
                  {
                    internalType: 'int256',
                    name: 'assetFee1',
                    type: 'int256'
                  },
                  {
                    internalType: 'int256',
                    name: 'debtFee0',
                    type: 'int256'
                  },
                  {
                    internalType: 'int256',
                    name: 'debtFee1',
                    type: 'int256'
                  }
                ],
                internalType: 'struct DataType.SubVaultInterest',
                name: 'interest',
                type: 'tuple'
              },
              {
                components: [
                  {
                    internalType: 'uint256',
                    name: 'receivedTradeAmount0',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'receivedTradeAmount1',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'receivedPremium',
                    type: 'uint256'
                  },
                  {
                    internalType: 'uint256',
                    name: 'paidPremium',
                    type: 'uint256'
                  }
                ],
                internalType: 'struct DataType.SubVaultPremium',
                name: 'premium',
                type: 'tuple'
              }
            ],
            internalType: 'struct DataType.SubVaultStatus[]',
            name: 'subVaults',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct DataType.VaultStatus',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      }
    ],
    name: 'getVaultValue',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint24',
            name: 'feeTier',
            type: 'uint24'
          },
          {
            internalType: 'address',
            name: 'token0',
            type: 'address'
          },
          {
            internalType: 'address',
            name: 'token1',
            type: 'address'
          },
          {
            internalType: 'bool',
            name: 'isMarginZero',
            type: 'bool'
          }
        ],
        internalType: 'struct DataType.InitializationParams',
        name: '_initializationParams',
        type: 'tuple'
      },
      {
        internalType: 'address',
        name: '_factory',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_chainlinkPriceFeed',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_vaultNFT',
        type: 'address'
      }
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'irmParams',
    outputs: [
      {
        internalType: 'uint256',
        name: 'baseRate',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'kinkRate',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'slope1',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'slope2',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'isSystemPaused',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      }
    ],
    name: 'isVaultSafe',
    outputs: [
      {
        internalType: 'bool',
        name: 'isSafe',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'lastTouchedTimestamp',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'swapRatio',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'closeRatio',
            type: 'uint256'
          }
        ],
        internalType: 'struct DataType.LiquidationOption',
        name: '_liquidationOption',
        type: 'tuple'
      }
    ],
    name: 'liquidate',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'subVaultId',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'asset0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'asset1',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debt0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'debt1',
            type: 'uint256'
          },
          {
            components: [
              {
                internalType: 'bool',
                name: 'isCollateral',
                type: 'bool'
              },
              {
                internalType: 'uint128',
                name: 'liquidity',
                type: 'uint128'
              },
              {
                internalType: 'int24',
                name: 'lowerTick',
                type: 'int24'
              },
              {
                internalType: 'int24',
                name: 'upperTick',
                type: 'int24'
              }
            ],
            internalType: 'struct DataType.LPT[]',
            name: 'lpts',
            type: 'tuple[]'
          }
        ],
        internalType: 'struct DataType.Position',
        name: '_position',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'bool',
            name: 'isLiquidationCall',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'swapAnyway',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'quoterMode',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'isQuoteZero',
            type: 'bool'
          },
          {
            internalType: 'uint8',
            name: 'marginMode0',
            type: 'uint8'
          },
          {
            internalType: 'uint8',
            name: 'marginMode1',
            type: 'uint8'
          },
          {
            internalType: 'int256',
            name: 'deltaMarginAmount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'deltaMarginAmount1',
            type: 'int256'
          },
          {
            internalType: 'bytes',
            name: 'metadata',
            type: 'bytes'
          }
        ],
        internalType: 'struct DataType.TradeOption',
        name: '_tradeOption',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'lowerSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upperSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'swapRatio',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          }
        ],
        internalType: 'struct DataType.OpenPositionOption',
        name: '_openPositionOptions',
        type: 'tuple'
      }
    ],
    name: 'openPosition',
    outputs: [
      {
        internalType: 'uint256',
        name: 'vaultId',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'int256',
            name: 'amount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'amount1',
            type: 'int256'
          }
        ],
        internalType: 'struct DataType.TokenAmounts',
        name: 'requiredAmounts',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'int256',
            name: 'amount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'amount1',
            type: 'int256'
          }
        ],
        internalType: 'struct DataType.TokenAmounts',
        name: 'swapAmounts',
        type: 'tuple'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'operator',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'pause',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_newOperator',
        type: 'address'
      }
    ],
    name: 'setOperator',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'unPause',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'amount0',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'amount1',
        type: 'uint256'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'uniswapV3MintCallback',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: 'amount0Delta',
        type: 'int256'
      },
      {
        internalType: 'int256',
        name: 'amount1Delta',
        type: 'int256'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'uniswapV3SwapCallback',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'baseRate',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'kinkRate',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'slope1',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'slope2',
            type: 'uint256'
          }
        ],
        internalType: 'struct InterestCalculator.IRMParams',
        name: '_irmParams',
        type: 'tuple'
      }
    ],
    name: 'updateIRMParams',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_vaultId',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'enum DataType.PositionUpdateType',
            name: 'positionUpdateType',
            type: 'uint8'
          },
          {
            internalType: 'uint256',
            name: 'subVaultId',
            type: 'uint256'
          },
          {
            internalType: 'bool',
            name: 'zeroForOne',
            type: 'bool'
          },
          {
            internalType: 'uint128',
            name: 'liquidity',
            type: 'uint128'
          },
          {
            internalType: 'int24',
            name: 'lowerTick',
            type: 'int24'
          },
          {
            internalType: 'int24',
            name: 'upperTick',
            type: 'int24'
          },
          {
            internalType: 'uint256',
            name: 'param0',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'param1',
            type: 'uint256'
          }
        ],
        internalType: 'struct DataType.PositionUpdate[]',
        name: 'positionUpdates',
        type: 'tuple[]'
      },
      {
        components: [
          {
            internalType: 'bool',
            name: 'isLiquidationCall',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'swapAnyway',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'quoterMode',
            type: 'bool'
          },
          {
            internalType: 'bool',
            name: 'isQuoteZero',
            type: 'bool'
          },
          {
            internalType: 'uint8',
            name: 'marginMode0',
            type: 'uint8'
          },
          {
            internalType: 'uint8',
            name: 'marginMode1',
            type: 'uint8'
          },
          {
            internalType: 'int256',
            name: 'deltaMarginAmount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'deltaMarginAmount1',
            type: 'int256'
          },
          {
            internalType: 'bytes',
            name: 'metadata',
            type: 'bytes'
          }
        ],
        internalType: 'struct DataType.TradeOption',
        name: '_tradeOption',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'lowerSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'upperSqrtPrice',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'swapRatio',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'deadline',
            type: 'uint256'
          }
        ],
        internalType: 'struct DataType.OpenPositionOption',
        name: '_openPositionOptions',
        type: 'tuple'
      }
    ],
    name: 'updatePosition',
    outputs: [
      {
        internalType: 'uint256',
        name: 'vaultId',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'int256',
            name: 'amount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'amount1',
            type: 'int256'
          }
        ],
        internalType: 'struct DataType.TokenAmounts',
        name: 'requiredAmounts',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'int256',
            name: 'amount0',
            type: 'int256'
          },
          {
            internalType: 'int256',
            name: 'amount1',
            type: 'int256'
          }
        ],
        internalType: 'struct DataType.TokenAmounts',
        name: 'swapAmounts',
        type: 'tuple'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'baseRate',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'kinkRate',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'slope1',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'slope2',
            type: 'uint256'
          }
        ],
        internalType: 'struct InterestCalculator.IRMParams',
        name: '_irmParams',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'baseRate',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'kinkRate',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'slope1',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'slope2',
            type: 'uint256'
          }
        ],
        internalType: 'struct InterestCalculator.IRMParams',
        name: '_premiumParams',
        type: 'tuple'
      }
    ],
    name: 'updateYearlyPremiumParams',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_amount0',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: '_amount1',
        type: 'uint256'
      }
    ],
    name: 'withdrawProtocolFee',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'ypParams',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'baseRate',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'kinkRate',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'slope1',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'slope2',
            type: 'uint256'
          }
        ],
        internalType: 'struct InterestCalculator.IRMParams',
        name: 'premiumParams',
        type: 'tuple'
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'baseRate',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'kinkRate',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'slope1',
            type: 'uint256'
          },
          {
            internalType: 'uint256',
            name: 'slope2',
            type: 'uint256'
          }
        ],
        internalType: 'struct InterestCalculator.IRMParams',
        name: 'irmParams',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  }
]

const _bytecode =
  '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__$d48eea142f8e4946a86e978d6ec5b9f014$__631619952e60216005600260008781526020019081526020016000206105426111af565b6040518563ffffffff1660e01b81526004016105619493929190615261565b60006040518083038186803b15801561057957600080fd5b505af415801561058d573d6000803e3d6000fd5b50505060008381526002602052604090819020905163a90989b160e01b815273__$d48eea142f8e4946a86e978d6ec5b9f014$__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__$b4a4919001844372a79711112cfb20c2b9$__916329399f429150610ded9084906004906002906005908301614fdc565b60006040518083038186803b158015610e0557600080fd5b505af4158015610e19573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610e419190810190613dfa565b9392505050565b602b54600160a01b900460ff1681565b602a546001600160a01b03163314610e825760405162461bcd60e51b815260040161088d90614b48565b602b54600160a01b900460ff1615610eac5760405162461bcd60e51b815260040161088d90614b80565b602b805460ff60a01b1916600160a01b1790556040517f9e87fac88ff661f02d44f95383c817fece4bce600a3dab7a54406878b965e75290600090a1565b600854600090610f02906001600160a01b0316612188565b905090565b610f0f61324a565b6000828152600360208181526040928390208351608081018552815481526001820154818401526002820154818601529281018054855181850281018501909652808652939491936060860193830182828015610f8b57602002820191906000526020600020905b815481526020019060010190808311610f77575b5050505050815250509050919050565b6000610fa56131f3565b610fad6131f3565b600073__$7ffffda71c6e7abde662efb5427d8d1c5d$__6307927e4b888860600151610fd7610eea565b89604001516040518563ffffffff1660e01b8152600401610ffb9493929190614d7d565b60006040518083038186803b15801561101357600080fd5b505af4158015611027573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261104f9190810190613af2565b905061105d88828888610bc7565b919a90995090975095505050505050565b600061107982612208565b600082815260036020526040908190209051630d5e377d60e11b815273__$a1fa80d38d689cae49e54718da49b6432c$__91631abc6efa916110c6919060049060059060029083016151cc565b60206040518083038186803b1580156110de57600080fd5b505af41580156110f2573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906111169190613c22565b92915050565b602a546001600160a01b031633146111465760405162461bcd60e51b815260040161088d90614b48565b6001600160a01b03811661115957600080fd5b602a80546001600160a01b0319166001600160a01b0383161790556040517fb3b3f5f64ab192e4b5fefde1f51ce9733bbdcf831951543b325aebd49cc27ec4906111a490839061497a565b60405180910390a150565b6040516310fe062760e11b815260009073__$a1fa80d38d689cae49e54718da49b6432c$__906321fc0c4e906111ea90600590600401614bf0565b60206040518083038186803b15801561120257600080fd5b505af4158015611216573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f029190613ad6565b600081815260036020526040808220905163b7f22f3960e01b815273__$a1fa80d38d689cae49e54718da49b6432c$__9163b7f22f3991611286919060049060059060029083016151cc565b60206040518083038186803b15801561129e57600080fd5b505af41580156112b2573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906111169190613c81565b6112de6131f3565b6112e66131f3565b602b54600160a01b900460ff16156113105760405162461bcd60e51b815260040161088d90614b80565b604080516001808252818301909252600091816020015b61132f613272565b81526020019060019003908161132757905050905061134d86612245565b8160008151811061135a57fe5b602002602001018190525061137187828787611500565b925092505094509492505050565b61138761324a565b61139083612208565b600083815260036020818152604092839020835160808101855281548152600182015481840152600282015481860152928101805485518185028101850190965280865293949193606086019383018282801561140c57602002820191906000526020600020905b8154815260200190600101908083116113f8575b505050919092525050604051635d8d458360e11b815273__$b4a4919001844372a79711112cfb20c2b9$__9263bb1a8b0692506114559160049060029060059089908401615071565b60006040518083038186803b15801561146d57600080fd5b505af4158015611481573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f19168201604052610e419190810190613f78565b6008546001600160a01b031633146114c057600080fd5b83156114dd576005546114dd906001600160a01b03163386611b61565b82156114fa576006546114fa906001600160a01b03163385611b61565b50505050565b6115086131f3565b6115106131f3565b602b54600160a01b900460ff161561153a5760405162461bcd60e51b815260040161088d90614b80565b82608001518042111561155f5760405162461bcd60e51b815260040161088d90614af4565b600073__$7ffffda71c6e7abde662efb5427d8d1c5d$__63f70cb736888860600151611589610eea565b89604001518a606001516040518663ffffffff1660e01b81526004016115b3959493929190614a2a565b60006040518083038186803b1580156115cb57600080fd5b505af41580156115df573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526116079190810190613af2565b9050611614888288611eeb565b8751602089015192975090955061162c9250906120d3565b505094509492505050565b606061111682611d05565b61164a6132a8565b6116526132a8565b61165a61251c565b5050604080516101008082018352600b548252600c54602080840191909152600d5483850152600e54606080850191909152600f5460808086019190915260105460a08087019190915260115460c08088019190915260125460e080890191909152885196870189526013548752601454958701959095526015549786019790975260165492850192909252601754908401526018549083015260195493820193909352601a549281019290925291565b600054610100900460ff168061172457506117246125b0565b80611732575060005460ff16155b61176d5760405162461bcd60e51b815260040180806020018281038252602e81526020018061545e602e913960400191505060405180910390fd5b600054610100900460ff16158015611798576000805460ff1961ff0019909116610100171660011790555b6001600160a01b0382166117ab57600080fd5b845160068054602080890151600580546001600160a01b039283166001600160a01b031991821617918290556040808d0151841662ffffff988916600160a01b90810262ffffff60a01b1990981697909717831617968790556060808e0151600980548e88169215158a0260ff60a01b19909116179094161790925580519182018152918316815291851692820192909252919092049092169082015261185285826125c1565b600880546001600160a01b03199081166001600160a01b0393841617909155602b80549091169185169190911790556001600a55611890600b6126a5565b61189a60136126a5565b5042600155602a80546001600160a01b0319163317905580156118c3576000805461ff00191690555b5050505050565b600080600073__$d48eea142f8e4946a86e978d6ec5b9f014$__63829c843160216005600260008b81526020019081526020016000206119086111af565b8a8a6040518763ffffffff1660e01b815260040161192b96959493929190615285565b60606040518083038186803b15801561194357600080fd5b505af4158015611957573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061197b91906144cd565b92509250925093509350939050565b602a546001600160a01b031633146119b45760405162461bcd60e51b815260040161088d90614b48565b602b54600160a01b900460ff166119dd5760405162461bcd60e51b815260040161088d90614b9c565b602b805460ff60a01b191690556040517f472cf038e2a5f33dbaa68760dbf94ab4e159535e6580c0ac63f8202c7c6c0bb290600090a1565b6008546001600160a01b03163314611a2c57600080fd5b6000841315611a4c57600554611a4c906001600160a01b03163386611b61565b60008313156114fa576006546114fa906001600160a01b03163385611b61565b602b54600160a01b900460ff1615611a965760405162461bcd60e51b815260040161088d90614b80565b600073__$7ffffda71c6e7abde662efb5427d8d1c5d$__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__$68d6cdd7134515db34cd8ee009462a2aba$__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__$d48eea142f8e4946a86e978d6ec5b9f014$__9163725acfd19161255b91600591601d9190600401614bff565b60206040518083038186803b15801561257357600080fd5b505af4158015612587573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906125ab9190613c81565b600155565b60006125bb3061306f565b15905090565b600081602001516001600160a01b031682600001516001600160a01b0316106125e957600080fd5b50805160208083015160409384015184516001600160a01b0394851681850152939091168385015262ffffff166060808401919091528351808403820181526080840185528051908301206001600160f81b031960a085015294901b6bffffffffffffffffffffffff191660a183015260b58201939093527fe34f199b19b2b4f47f68442619d555527d244f78a3297ea89325f843f87b8b5460d5808301919091528251808303909101815260f5909101909152805191012090565b670de0b6b3a764000060048201819055600590910155565b602b546040805163186e33a360e21b8152905184926001600160a01b0316916361b8ce8c9160048083019260209291908290030181600087803b15801561270357600080fd5b505af1158015612717573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061273b9190613c81565b81106127595760405162461bcd60e51b815260040161088d90614bb8565b6000831161276657600080fd5b6127708383612b27565b6000838152600360205260409081902090516349b3bd7960e11b815273__$a1fa80d38d689cae49e54718da49b6432c$__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__$d48eea142f8e4946a86e978d6ec5b9f014$__63a5d330ad82600460026005876021612be16111af565b6040518863ffffffff1660e01b8152600401612c039796959493929190615015565b60006040518083038186803b158015612c1b57600080fd5b505af4158015612c2f573d6000803e3d6000fd5b5050604051637ce761e760e01b815273__$d48eea142f8e4946a86e978d6ec5b9f014$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'

type ControllerConstructorParams =
  | [linkLibraryAddresses: ControllerLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>

const isSuperArgs = (
  xs: ControllerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === 'string' ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    '_isInterface' in xs[0]
  )
}

export class Controller__factory extends ContractFactory {
  constructor(...args: ControllerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args)
    } else {
      const [linkLibraryAddresses, signer] = args
      super(
        _abi,
        Controller__factory.linkBytecode(linkLibraryAddresses),
        signer
      )
    }
  }

  static linkBytecode(
    linkLibraryAddresses: ControllerLibraryAddresses
  ): string {
    let linkedBytecode = _bytecode

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$d48eea142f8e4946a86e978d6ec5b9f014\\$__', 'g'),
      linkLibraryAddresses[
        'src/libraries/InterestCalculator.sol:InterestCalculator'
      ]
        .replace(/^0x/, '')
        .toLowerCase()
    )

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$b4a4919001844372a79711112cfb20c2b9\\$__', 'g'),
      linkLibraryAddresses['src/libraries/VaultLib.sol:VaultLib']
        .replace(/^0x/, '')
        .toLowerCase()
    )

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$7ffffda71c6e7abde662efb5427d8d1c5d\\$__', 'g'),
      linkLibraryAddresses['src/libraries/PositionLib.sol:PositionLib']
        .replace(/^0x/, '')
        .toLowerCase()
    )

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$a1fa80d38d689cae49e54718da49b6432c\\$__', 'g'),
      linkLibraryAddresses[
        'src/libraries/logic/LiquidationLogic.sol:LiquidationLogic'
      ]
        .replace(/^0x/, '')
        .toLowerCase()
    )

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$68d6cdd7134515db34cd8ee009462a2aba\\$__', 'g'),
      linkLibraryAddresses[
        'src/libraries/logic/UpdatePositionLogic.sol:UpdatePositionLogic'
      ]
        .replace(/^0x/, '')
        .toLowerCase()
    )

    return linkedBytecode
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Controller> {
    return super.deploy(overrides || {}) as Promise<Controller>
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {})
  }
  attach(address: string): Controller {
    return super.attach(address) as Controller
  }
  connect(signer: Signer): Controller__factory {
    return super.connect(signer) as Controller__factory
  }
  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): ControllerInterface {
    return new utils.Interface(_abi) as ControllerInterface
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Controller {
    return new Contract(address, _abi, signerOrProvider) as Controller
  }
}

export interface ControllerLibraryAddresses {
  ['src/libraries/InterestCalculator.sol:InterestCalculator']: string
  ['src/libraries/VaultLib.sol:VaultLib']: string
  ['src/libraries/PositionLib.sol:PositionLib']: string
  ['src/libraries/logic/LiquidationLogic.sol:LiquidationLogic']: string
  ['src/libraries/logic/UpdatePositionLogic.sol:UpdatePositionLogic']: string
}
